import React, { useContext, useState, setState } from "react";
import { Link, useHistory } from "react-router-dom";
// import { FormGroup, FormControl, Figure, Row, Col } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { MdClose, MdCheck, MdAttachFile } from "react-icons/md";
import { Settings, Task } from "../../helpers/Contexts";
import * as API from "../../api";
import TextField from "../../shared/TextField";

const TaskField = ({
  attribute,
  data,
  name,
  value,
  fieldType,
  optionValues,
  description,
  formHandler,
}) => {
  const settings = useContext(Settings);
  const [isSubmitting, setIsSubmitting] = useState(null);
  const [isEditing, setIsEditing] = useState(null);
  const [error, setError] = useState(null);
  const history = useHistory();

  const saveTaskField = (values) => {
    values["task"][name] = values[name];
    setIsSubmitting(true);
    let id = data.task.id;
    return formHandler(values)
      .then((res) => {
        setIsSubmitting(false);
        setIsEditing(false);
      })
      .catch((err) => {
        setIsSubmitting(false);
        setIsEditing(false);
      });
  };

  let initialValues = {
    task: {
      id: data.task.id,
    },
  };
  initialValues["task"][name] = value;
  let handleChange = () => {};
  let handleBlur = () => {};

  const SelectOptions = ({ name, onChange }) => {
    let options = optionValues.map((item, i) => {
      return (
        <option key={item.value} value={item.value}>
          {item.label}
        </option>
      );
    });

    return (
      <>
        <select
          style={{ width: "auto", float: "left" }}
          className="form-control"
          onChange={onChange}
          name={name}
        >
          {options}
        </select>
      </>
    );
  };

  const onSubmit = (values) => {
    setIsSubmitting(true);
    saveTaskField(values);
  };

  const TaskFieldForm = ({ values, setFieldValue, isSubmitting }) => {
    return (
      <Form>
        <div className="task-field-form-container">
          {fieldType == "select" ? (
            <>
              <SelectOptions onChange={(e) => setFieldValue(name, e.target.value)} name={name} />
            </>
          ) : (
            <>
              <input
                style={{ width: "auto" }}
                type="text"
                placeholder={description}
                onChange={(e) => setFieldValue(name, e.target.value)}
                name={"task[" + name + "]"}
              />
            </>
          )}

          <div className="p-t-md inline check-cancel-buttons">
            {isSubmitting == true ? (
              <>
                <i className="fa fa-spinner fa-spin m-l-lg blue-text" />
              </>
            ) : (
              <button className="check small" type={"submit"} disabled={isSubmitting}>
                <MdCheck className="check-icon" />
              </button>
            )}
            <button className="cancel small" onClick={() => setIsEditing(false)}>
              <MdClose className="cancel-icon" />
            </button>
            <br />
          </div>
        </div>
      </Form>
    );
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        onChange={handleChange}
        handleBlur={handleBlur}
        onSubmit={onSubmit}
      >
        {isEditing == true ? (
          ({
            values,
            errors,
            touched,
            setFieldValue,
            isSubmitting,
            setIsSubmittingsaveTaskField,
          }) => (
            <TaskFieldForm
              values={values}
              etIsSubmitting={setIsSubmitting}
              setFieldValue={setFieldValue}
            />
          )
        ) : (
          <>
            <a className="submit-form-field">
              <i className="fa fa-edit blue-text" onClick={() => setIsEditing(true)} />
            </a>
          </>
        )}
      </Formik>
    </>
  );
};

export default TaskField;
